interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function ApiDocsIcon(props: Props) {
  const { size = 17, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g stroke="currentColor">
        <path d="M13.96 1H3.04a2 2 0 0 0-2 2v11c0 1.1.9 2 2 2h10.92a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Z" />
        <path
          d="m4.15 8.5 2.04 2.18-2.07 2.21m4.92.05h3.84M1.15 4.1h14.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
